module.exports = __webpack_public_path__ + "img/section2_pic2@3x.02ade192.png";